var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRateActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.049 2.42664C10.3483 1.50537 11.6517 1.50538 11.951 2.42664L13.4699 7.10055C13.6038 7.51254 13.9877 7.79148 14.4209 7.79149L19.3354 7.79168C20.3041 7.79172 20.7068 9.03127 19.9232 9.60067L15.9474 12.4895C15.5969 12.7441 15.4503 13.1955 15.5841 13.6075L17.1026 18.2815C17.4019 19.2028 16.3475 19.9689 15.5638 19.3995L11.5878 16.511C11.2373 16.2564 10.7627 16.2564 10.4122 16.511L6.43622 19.3995C5.65252 19.9689 4.5981 19.2028 4.8974 18.2815L6.41589 13.6075C6.54974 13.1955 6.40309 12.7441 6.05263 12.4895L2.07683 9.60067C1.29317 9.03127 1.69592 7.79172 2.66461 7.79168L7.57911 7.79149C8.01231 7.79148 8.39623 7.51254 8.53011 7.10055L10.049 2.42664Z",
    stroke: "#6B7280",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRateActive);
export default __webpack_public_path__ + "static/media/topRateActive.d3bcba352a23fc8ff9233c05b91007a1.svg";
export { ForwardRef as ReactComponent };